module.exports = __webpack_public_path__ + "static/media/email_icon.7e99b076.png";